<template>
    <div>
        Page not found!
    </div>
</template>

<script>
export default {
    name: 'page404',
    components: {
        //
    }
}
</script>